import { useState } from 'react'
import type { AuditLog, AuditLogQuery } from '@/api/audit'
import { useAuditLogs, useAuditOptions } from '@/hooks/useAuditLogs'
import { AuditLogFilterBar } from './components/AuditLogFilterBar'
import { AuditLogTable } from './components/AuditLogTable'
import { AuditLogDetailDrawer } from './components/AuditLogDetailDrawer'
import { DEFAULT_PAGE_SIZE } from '@/components/common/ListPagination'

export function AuditLogsPage() {
	const [query, setQuery] = useState<AuditLogQuery>({ page: 1, page_size: DEFAULT_PAGE_SIZE })
	const [selected, setSelected] = useState<AuditLog | null>(null)
	const { data, isLoading, error } = useAuditLogs(query)
	const { data: options } = useAuditOptions()

	return (
		<div className="space-y-6">
			<div>
				<h1 className="text-2xl font-bold tracking-tight">操作日志</h1>
				<p className="text-muted-foreground">查看后台关键操作记录</p>
			</div>
			<AuditLogFilterBar query={query} modules={options?.modules || []} actions={options?.actions || []} onChange={setQuery} />
			<AuditLogTable
				logs={data?.list || []}
				total={data?.total || 0}
				page={query.page}
				pageSize={query.page_size}
				loading={isLoading}
				error={error as Error | null}
				onPageChange={(page) => setQuery({ ...query, page })}
				onPageSizeChange={(pageSize) => setQuery({ ...query, page: 1, page_size: pageSize })}
				onSelect={setSelected}
			/>
			<AuditLogDetailDrawer log={selected} open={!!selected} onOpenChange={(open) => !open && setSelected(null)} />
		</div>
	)
}
